import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove critical shell after React mounts (it provided instant FCP)
const shell = document.getElementById('critical-shell');
if (shell) shell.remove();

createRoot(document.getElementById("root")!).render(<App />);
